import { Time } from '../types'

export const isTimeNaN = (time: Time): boolean => {
  if (time.hour === null) return false
  if (time.minute === null) return false
  if (isNaN(time.hour)) return true
  if (isNaN(time.minute)) return true

  return false
}
